export async function withLogWsTicket(baseUrl: string): Promise<string> {
  try {
    const res = await fetch('/api/logs/ws-ticket', { credentials: 'same-origin' });
    if (!res.ok) return baseUrl;
    const body = (await res.json()) as { ticket?: string };
    if (!body.ticket) return baseUrl;
    const url = new URL(baseUrl);
    url.searchParams.set('ticket', body.ticket);
    return url.toString();
  } catch {
    return baseUrl;
  }
}
